import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

import TermsOfService from './termsOfService/TermsOfService';
import './AcceptTermsOfService.scss';

export interface IAcceptTermsOfServiceDispatchProps {
  accept: () => void;
}

const AcceptTermsOfService: React.FC<IAcceptTermsOfServiceDispatchProps> = ({
  accept,
}) => {
  const { t } = useTranslation();

  return (
    <div className='login accept-terms-of-service text-center pt-2'>
      <h1 className='fcolor--primary-brand'>{t('title')}</h1>
      <Helmet>
        <title>{t('termsOfUse_title')}</title>
      </Helmet>
      <div className='terms-container mt-1'>
        <div className='p-2 text-left'>
          <TermsOfService />
        </div>
      </div>
      <div className='mt-2'>
        <button className='btn btn-primary btn-sm' onClick={() => accept()}>
          {t('termsOfUse_iAccept', { uppercase: true })}
        </button>
      </div>
    </div>
  );
};

export default AcceptTermsOfService;
